import React from 'react'
import {Switch} from 'react-router-dom'
import PRoute from './privateRouter'
import * as AppUrl from '../constants/appUrl'

import Home from '../pages/home'
import PermissionManagement from '../pages/permissionManagement'
import UserManagement from '../pages/userManagement'
import RoleManagement from '../pages/roleManagement'
import ApprovePermission from '../pages/approvePermission'
import ApiManagement from '../pages/apiManagement'
import MessageManagement from '../pages/messageManagement'
import MessageDetails from '../pages/messageManagement/components/MessageDetails'
import IndexManagement from '../pages/indexManagement'
import MappingManagement from '../pages/mappingManagement'
import ConnectionMonitor from '../pages/connectionMonitor'
import CustomerManagement from '../pages/customerManagement'
import CustomerMasterData from '../pages/customerMasterData'
import IndexSearch from '../pages/indexSearch'
import MessagePayload from '../pages/messageManagement/components/MessagePayload'
import Transportation from '../pages/apiToolsTransportation'
import massResend from '../pages/apiToolsUploadPayload'
import UploadDataResource from '../pages/apiToolsDataResource'
import StreamManagement from '../pages/streamManagement'
import JobManagement from '../pages/jobManagement'
import ReportEBilling from '../pages/reportEBilling'
import ReportOrder from '../pages/reportOrdeer'
import ShipTo from '../pages/webEDIShipTo'
import WebEDI from '../pages/webEDI'
import UserEmailManagement from '../pages/userEmailManagement'

import BusinessType from '../pages/businessType'
import DataTarget from '../pages/dataTarget'
import DataSource from '../pages/dataSource'
import AzureAppRegistration from '../pages/azureAppRegistration'
import AzureKeyVault from '../pages/azureKeyVault'
import GroovyManagement from '../pages/groovyManagement'
import FormulaInfo from '../pages/formulaInfo'
import FormulaType from '../pages/formulaType'
import LOGIN from '../pages/login'
import CallBack from '../pages/callback'

import RulesManagement from '../pages/rulesManagement'
import EmailManagement from '../pages/emailManagement'
import AuditLogs from '../pages/auditLogs'
import ReportManagement from '../pages/reportManagement'
import ReportTag from '../pages/reportTag'
import TabsManager from '../pages/tabsManager/TabsManager'

import DataFlowMonitoringConfig from '../pages/dataFlowMonitoringConfig'
import DataFlowLog from '../pages/dataFlowLog'

import MarketingGroupManagement from '../pages/marketingGroupManagement'
import SmsSignature from '../pages/marketingSmsSignature'
import SmsTemplate from '../pages/marketingSmsTemplate'
import ResourcePool from '../pages/marketingResourcePool'
// import AddressBook from '../pages/marketingAddressBook'
import ShortLink from '../pages/marketingShortLink'
import SmsManagement from '../pages/marketingSmsManagement'
import SmsManagementDetails from '../pages/marketingSmsManagementDetails'
import EmailAddress from '../pages/emailAddress'
import EmailTemplate from '../pages/emailTemplate'
import EmailList from '../pages/emailList'
import FatigueConfig from '../pages/fatigueConfig'
import RemarkTemplateList from '../pages/remarkTemplateList'
import ManualCall from '../pages/manualOutboundCall'
import IntelligentCallModel from '../pages/intelligentOutboundCallModel'
import IntelligentCall from '../pages/intelligentOutboundCall'
import IntelligentCallDetails from '../pages/intelligentOutboundCallDetails'

import MiceCadOea from '../pages/miceCadOea'
import MiceCadOeaSchedule from '../pages/miceCadOeaSchedule'
import ChatBi from '../pages/chatbi'
import Harness from '../pages/harness'
import ThemeSetting from '../pages/themeSetting'

import DriveList from '../pages/driveList'
import DrivePermission from '../pages/drivePermission'
import DriveFileSearch from '../pages/driveFileSearch'

import TerminologyConfig from '../pages/intelligentQuery/terminologyConfig'
import SqlExample from '../pages/intelligentQuery/sqlExample'
import QueryAudit from '../pages/intelligentQuery/queryAudit'
import {CHATBI} from "../constants/appUrl";


const AppRouter = () => (
  <Switch>
    <PRoute exact path={AppUrl.HOME} component={Home}/>
    <PRoute exact path={AppUrl.PERMISSIONMANAGEMENT} component={PermissionManagement}/>
    <PRoute exact path={AppUrl.USERMANAGEMENT} component={UserManagement}/>
    <PRoute exact path={AppUrl.ROLEMANAGEMENT} component={RoleManagement}/>
    <PRoute exact path={AppUrl.APPROVEPERMISSION} component={ApprovePermission}/>
    <PRoute exact path={AppUrl.MESSAGEMANAGEMENT} component={MessageManagement}/>
    <PRoute exact path={AppUrl.MESSAGEDETAILS} component={MessageDetails}/>
    <PRoute exact path={AppUrl.INDEXMANAGEMENT} component={IndexManagement}/>
    <PRoute exact path={AppUrl.MESSAGEPAYLOAD} component={MessagePayload}/>
    <PRoute exact path={AppUrl.INDEXSEARCH} component={IndexSearch}/>
    <PRoute exact path={AppUrl.APIMANAGEMENT} component={ApiManagement}/>
    <PRoute exact path={AppUrl.MAPPINGMANAGEMENT} component={MappingManagement}/>
    <PRoute exact path={AppUrl.CONNECTIONMONITOR} component={ConnectionMonitor}/>
    <PRoute exact path={AppUrl.CUSTOMERMANAGEMENT} component={CustomerManagement}/>
    <PRoute exact path={AppUrl.CUSTOMERMASTERDATA} component={CustomerMasterData}/>
    <PRoute exact path={AppUrl.TRANSPORTATION} component={Transportation}/>
    <PRoute exact path={AppUrl.MASSRESEND} component={massResend}/>
    <PRoute exact path={AppUrl.UPLOADDATARESOURCE} component={UploadDataResource}/>
    <PRoute exact path={AppUrl.STREAMMANAGEMENT} component={StreamManagement}/>
    <PRoute exact path={AppUrl.JOBMANAGEMENT} component={JobManagement}/>
    <PRoute exact path={AppUrl.REPORTEBILLING} component={ReportEBilling}/>
    <PRoute exact path={AppUrl.REPORTORDER} component={ReportOrder}/>
    <PRoute exact path={AppUrl.SHIPTO} component={ShipTo}/>
    <PRoute exact path={AppUrl.WEBEDI} component={WebEDI}/>
    <PRoute exact path={AppUrl.USEREMAILMANAGEMENT} component={UserEmailManagement}/>

    <PRoute exact path={AppUrl.BUSINESSTYPE} component={BusinessType}/>
    <PRoute exact path={AppUrl.DATATARGET} component={DataTarget}/>
    <PRoute exact path={AppUrl.DATASOURCE} component={DataSource}/>
    <PRoute exact path={AppUrl.AZUREAPPREGISTRATION} component={AzureAppRegistration}/>
    <PRoute exact path={AppUrl.AZUREKEYVAULT} component={AzureKeyVault}/>
    <PRoute exact path={AppUrl.GROOVYMANAGEMENT} component={GroovyManagement}/>
    <PRoute exact path={AppUrl.FORMULAINFO} component={FormulaInfo}/>
    <PRoute exact path={AppUrl.FORMULATYPE} component={FormulaType}/>
    <PRoute exact path={AppUrl.CALLBACK} component={CallBack}/>
    <PRoute exact path={AppUrl.LOGIN} component={LOGIN}/>

    {/*<PRoute exact path={AppUrl.RULESMANAGEMENT} component={RulesManagement}/>*/}
    <PRoute exact path={AppUrl.EMAILMANAGEMENT} component={EmailManagement}/>
    <PRoute exact path={AppUrl.CHATBI} component={ChatBi}/>
    <PRoute exact path={AppUrl.HARNESS} component={Harness}/>


    <PRoute exact path={AppUrl.AUDITLOGS} component={AuditLogs}/>

    {/* <PRoute exact path={AppUrl.REPORTMANAGEMENT} component={ReportManagement}/> */}
    <PRoute exact path={AppUrl.REPORTMANAGEMENT} component={TabsManager}/>
    <PRoute exact path={AppUrl.REPORTTAG} component={TabsManager}/>
    <PRoute exact path={AppUrl.REPORTPAGE} component={TabsManager}/>
    <PRoute path={AppUrl.REPORTPAGE_WITH_ID} component={TabsManager}/>
    <PRoute exact path={`${AppUrl.PBIREPORTPAGE}`} component={TabsManager}/>
    <PRoute path={AppUrl.PBIREPORTPAGE_WITH_ID} component={TabsManager}/>

    
    <PRoute exact path={AppUrl.DATAFLOWMONITORINGCONFIG} component={DataFlowMonitoringConfig}/>
    <PRoute exact path={AppUrl.DATAFLOWLOG} component={DataFlowLog}/>

    <PRoute exact path={AppUrl.MARKETINGGROUPMANAGEMENT} component={MarketingGroupManagement}/>
    <PRoute exact path={AppUrl.SMSSIGNATURE} component={SmsSignature}/>
    <PRoute exact path={AppUrl.SMSTEMPLATE} component={SmsTemplate}/>
    <PRoute exact path={AppUrl.RESOURCEPOOL} component={ResourcePool}/>
    {/* <PRoute exact path={AppUrl.ADDRESSBOOK} component={AddressBook}/> */}
    <PRoute exact path={AppUrl.SHORTLINK} component={ShortLink}/>
    <PRoute exact path={AppUrl.SMSMANAGEMENT} component={SmsManagement}/>
    <PRoute exact path={AppUrl.SMSMANAGEMENTDETAILS} component={SmsManagementDetails}/>
    <PRoute exact path={AppUrl.EMAILADDRESS} component={EmailAddress}/>
    <PRoute exact path={AppUrl.EMAILTEMPLATE} component={EmailTemplate}/>
    <PRoute exact path={AppUrl.EMAILLIST} component={EmailList}/>
    <PRoute exact path={AppUrl.FATIGUECONFIG} component={FatigueConfig}/>
    <PRoute exact path={AppUrl.REMARKTEMPLATELIST} component={RemarkTemplateList}/>
    <PRoute exact path={AppUrl.MANUALCALLMANAGEMENT} component={ManualCall}/>
    <PRoute exact path={AppUrl.INTELLIGENTCALLMODEL} component={IntelligentCallModel}/>
    <PRoute exact path={AppUrl.INTELLIGENTCALLMANAGEMENT} component={IntelligentCall}/>
    <PRoute exact path={AppUrl.INTELLIGENTCALLDETAILS} component={IntelligentCallDetails}/>

    <PRoute exact path={AppUrl.MICECADOEA} component={MiceCadOea}/>
    <PRoute exact path={AppUrl.MICECADOEASCHEDULE} component={MiceCadOeaSchedule}/>
    <PRoute exact path={AppUrl.THEMESETTING} component={ThemeSetting}/>

    <PRoute exact path={AppUrl.DRIVELIST} component={DriveList}/>
    <PRoute exact path={AppUrl.DRIVEPERMISSION} component={DrivePermission}/>
    <PRoute exact path={AppUrl.DRIVESEARCH} component={DriveFileSearch}/>

    <PRoute exact path={AppUrl.TERMINOLOGYCONFIG} component={TerminologyConfig}/>
    <PRoute exact path={AppUrl.SQLEXAMPLE} component={SqlExample}/>
    <PRoute exact path={AppUrl.QUERYAUDIT} component={QueryAudit}/>
  </Switch>
)

export default AppRouter
